import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

import { useFormCreateUnitys } from 'src/controllers/Unitys/CreateUnitysController';
import LoadingScreen from '../../components/LoadingScreen';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';

const UnityForm: React.FC = () => {
    const { getUnityFormController, handleUnityFormController } = useFormCreateUnitys();

    const [registerFinished, setRegisterFinished] = useState(false);

    const history = useHistory();

    const unityType = [
        { label: 'Outros...', code: 0 },
        { label: 'Oficina ou Garagem', code: 1 }
    ];

    useEffect(() => {
        if (getUnityFormController.unityResponse?.status === 200) {
            setRegisterFinished(true);
        }
        if (getUnityFormController.unityEditedResponse?.status === 200 && !getUnityFormController.unityResponse) {
            setRegisterFinished(false);
        }
    }, [getUnityFormController.unityResponse, getUnityFormController.unityEditedResponse]);

    return (
        <div style={{ height: '100%' }} className="card p-align-center p-justify-center">
            <Toast ref={getUnityFormController.toast} />
            {getUnityFormController.loading ? <LoadingScreen color="#0388e5" /> : <></>}
            <h5>Cadastro de unidade</h5>
            <div className="p-grid p-fluid">
                <div className="p-field p-col-12 p-md-12">
                    <label htmlFor="nome">Nome</label>
                    <InputText disabled={registerFinished} id="nome" maxLength={150}
                        {...getUnityFormController.formik.getFieldProps('NOME')}
                        onChange={getUnityFormController.formik.handleChange('NOME')}
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getUnityFormController.formik.touched.NOME && getUnityFormController.formik.errors.NOME,
                        'popup-form-inactive': !(getUnityFormController.formik.touched.NOME && getUnityFormController.formik.errors.NOME),
                    })}
                    >{getUnityFormController.formik.errors.NOME}</div>
                </div>

                <div className="p-field p-col-12 p-md-6">
                    <label htmlFor="email">Email</label>
                    <InputText disabled={registerFinished} id="email" maxLength={150} placeholder="unidade@email.com.br"
                        {...getUnityFormController.formik.getFieldProps('EMAIL')}
                        onChange={getUnityFormController.formik.handleChange('EMAIL')}
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getUnityFormController.formik.touched.EMAIL && getUnityFormController.formik.errors.EMAIL,
                        'popup-form-inactive': !(getUnityFormController.formik.touched.EMAIL && getUnityFormController.formik.errors.EMAIL),
                    })}
                    >{getUnityFormController.formik.errors.EMAIL}</div>
                </div>

                <div className="p-field p-col-12 p-md-3">
                    <label htmlFor="telefone">Telefone</label>
                    <InputText disabled={registerFinished} id="telefone" maxLength={20}
                        {...getUnityFormController.formik.getFieldProps('TELEFONE')}
                        onChange={getUnityFormController.formik.handleChange('TELEFONE')}
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getUnityFormController.formik.touched.TELEFONE && getUnityFormController.formik.errors.TELEFONE,
                        'popup-form-inactive': !(getUnityFormController.formik.touched.TELEFONE && getUnityFormController.formik.errors.TELEFONE),
                    })}
                    >{getUnityFormController.formik.errors.TELEFONE}</div>
                </div>

                <div className="p-field p-col-12 p-md-3">
                    <label htmlFor="tipounidade">Tipo de Unidade</label>
                    <Dropdown id="tipounidade" inputId="tipounidade" disabled={registerFinished}
                        {...getUnityFormController.formik.getFieldProps('TIPOUNIDADE')}
                        onChange={(e) => { getUnityFormController.formik.setFieldValue('TIPOUNIDADE', e.value) }}
                        options={unityType} optionLabel="label" optionValue="code"
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getUnityFormController.formik.touched.TIPOUNIDADE && getUnityFormController.formik.errors.TIPOUNIDADE,
                        'popup-form-inactive': !(getUnityFormController.formik.touched.TIPOUNIDADE && getUnityFormController.formik.errors.TIPOUNIDADE),
                    })}
                    >{getUnityFormController.formik.errors.TIPOUNIDADE}</div>
                </div>
            </div>

            <div className="p-fluid p-grid p-justify-between">
                {getUnityFormController.unityResponse?.status === 200 && !registerFinished ?
                    <div className="p-col-12 p-md-4">
                        <Button
                            type="button"
                            label="Salvar Alterações"
                            onClick={() => {
                                getUnityFormController.formik.handleSubmit()
                            }}
                        />
                    </div> :
                    getUnityFormController.unityResponse?.status === 200 && registerFinished ?
                        <div className="p-col-12 p-md-6 p-fluid p-grid" >
                            <div className="p-col-12 p-md-5">
                                <Button
                                    type="button"
                                    label="Editar"
                                    onClick={() => {
                                        setRegisterFinished(false);
                                    }}
                                />
                            </div>
                            <div className="p-col-12 p-md-5" >
                                <Button
                                    icon="pi pi-plus"
                                    type="button"
                                    className="p-button-success"
                                    label="Cadastrar novo"
                                    onClick={() => {
                                        getUnityFormController.formik.resetForm();
                                        setRegisterFinished(false);
                                        handleUnityFormController.setUnityResponse(null);
                                    }}
                                />
                            </div>
                        </div> :
                        <div className="p-col-12 p-md-4">
                            <Button
                                type="button"
                                label="Cadastrar"
                                onClick={() => getUnityFormController.formik.handleSubmit()}
                            />
                        </div>
                }

                <div className="p-col-12 p-md-4">
                    <Button
                        type="button"
                        className="p-button-secondary"
                        label="Voltar para listagem"
                        onClick={() => history.goBack()}
                    />
                </div>
            </div>
        </div>
    );
};

export default UnityForm;